import { Text } from "@mantine/core";

interface NotificationTitleProps {
  notificationTypeName: string;
  title: string;
  trailerLicenceNumber: string | null;
}

const NotificationTitle: React.FC<NotificationTitleProps> = ({
  notificationTypeName,
  title,
  trailerLicenceNumber,
}) => {
  return (
    <Text lh={1} size={"md"} fw={600}>
      {notificationTypeName && <span>{notificationTypeName}&nbsp;</span>}

      {title}

      {trailerLicenceNumber && <span>&nbsp;{trailerLicenceNumber}</span>}
    </Text>
  );
};

export default NotificationTitle;
